module.exports = __webpack_public_path__ + "static/media/paper_grid.c9b55fb3.svg";